// Shared form styling constants for client design system
// Used by both Immigration and Fingerprinting domains

/**
 * Input field styling classes
 * - 50px height
 * - 16px border-radius
 * - 1px border with Neutral/50 color
 * - White background
 * - Client-primary focus ring
 */
export const INPUT_CLASSES =
  '!h-[50px] rounded-2xl border border-client-neutral-50 bg-white !px-4 !py-3 text-sm text-client-neutral-950 placeholder:text-client-neutral-500 shadow-none focus-visible:ring-client-primary'

/**
 * Select trigger styling classes
 * - 50px height
 * - 16px border-radius
 * - 1px border with Neutral/50 color
 * - White background
 * - Left-aligned text with truncation
 */
export const SELECT_TRIGGER_CLASSES =
  '!h-[50px] w-full rounded-2xl border border-client-neutral-50 bg-white !px-4 !py-3 text-sm text-client-neutral-950 shadow-none [&>span]:text-left [&>span]:block [&>span]:w-full [&>span]:truncate'

/**
 * Option card styling classes for radio selections
 */
export const OPTION_CARD_CLASSES = {
  /** Base styles for all option cards */
  base: 'flex cursor-pointer items-start gap-3 rounded-2xl border bg-white px-4 py-3 text-left transition-colors',
  /** Styles when option is selected */
  selected: 'border-client-primary shadow-[0_8px_16px_rgba(55,81,255,0.12)]',
  /** Styles when option is not selected */
  unselected: 'border-[#D8D9DB]',
} as const

/**
 * Step progress indicator colors
 */
export const STEP_PROGRESS_COLORS = {
  /** Color for completed steps (filled circle and progress line) */
  completed: '#316ABA',
  /** Border color for current step */
  current: '#2563EB',
  /** Border color for upcoming steps */
  upcoming: '#D7DCE3',
  /** Background color for progress line */
  line: '#E5E7EB',
  /** Text color for completed step labels */
  completedText: '#081B23',
  /** Text color for current step labels */
  currentText: '#316ABA',
  /** Text color for upcoming step labels */
  upcomingText: '#798489',
} as const

/**
 * Info box variant colors
 */
export const INFO_BOX_VARIANTS = {
  warning: {
    background: '#FDF6E3',
    border: '#F4E3B5',
    titleColor: '#8A6D1F',
    textColor: '#6F5B2C',
  },
  error: {
    background: '#FEF2F2',
    border: '#FECACA',
    titleColor: '#991B1B',
    textColor: '#B91C1C',
  },
  info: {
    background: '#F3F7FF',
    border: '#BFDBFE',
    titleColor: '#1E40AF',
    textColor: '#1D4ED8',
  },
} as const

export type InfoBoxVariant = keyof typeof INFO_BOX_VARIANTS
